export function printHtmlDocument(title, bodyHtml) {
  const frame = document.createElement("iframe");
  frame.setAttribute("aria-hidden", "true");
  frame.style.position = "fixed";
  frame.style.right = "0";
  frame.style.bottom = "0";
  frame.style.width = "0";
  frame.style.height = "0";
  frame.style.border = "0";
  document.body.appendChild(frame);

  const doc = frame.contentDocument;
  doc.open();
  doc.write(`<!doctype html><html><head><meta charset="utf-8"><title>${title}</title>
<style>
  @page { size: A4; margin: 10mm; }
  body { font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: #111; }
  h1 { font-size: 16px; margin: 0 0 6px; }
  h2 { font-size: 13px; margin: 12px 0 6px; }
  table { width: 100%; border-collapse: collapse; }
  th, td { border: 1px solid #ccc; padding: 3px 5px; text-align: left; vertical-align: top; }
  th { background: #f3f4f6; font-size: 10px; text-transform: uppercase; }
  .muted { color: #6b7280; }
  .right { text-align: right; }
  .page-break { page-break-before: always; }
  img.doc { max-width: 100%; max-height: 240mm; }
</style></head><body>${bodyHtml}</body></html>`);
  doc.close();

  const cleanup = () => {
    if (frame.parentNode) frame.parentNode.removeChild(frame);
  };

  return new Promise((resolve) => {
    const run = () => {
      frame.contentWindow.focus();
      frame.contentWindow.print();
      setTimeout(() => {
        cleanup();
        resolve();
      }, 400);
    };
    if (frame.contentDocument.readyState === "complete") run();
    else frame.onload = run;
  });
}

export function esc(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");
}
